// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTooltip } from 'ducks/tooltip';

const Tooltip = ({ Component, children, dispatch }) => (
  <span
    onMouseOver={() => dispatch(setTooltip(Component))}
    onMouseOut={() => dispatch(setTooltip(null))}
  >
    {children}
  </span>
);

Tooltip.propTypes = {
  Component: PropTypes.node,
  children: PropTypes.node,
  dispatch: PropTypes.func,
};

export default connect()(Tooltip);
